import script from "./customer-select.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-select.vue?vue&type=script&setup=true&lang=js"

import "./customer-select.vue?vue&type=style&index=0&id=4b6ac8fb&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6ac8fb"]])

export default __exports__